import type { FaireProductEntity } from "../../entity_types/product";

export const p_4v6fgue0zf: FaireProductEntity = {
  token: "p_4v6fgue0zf",
  type: "product",
  name: "Balsam Fir \u2013 22oz Winter Holiday Scented Jar Candle",
  brandName: "A Cheerful Giver",
  imageUrl:
    "https://cdn.faire.com/fastly/189cdd684ba14e18ce4eb9cc01c1480768c9f092fbef250f9df3c19db304df99.jpeg",
  priceDollars: 12,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/01445ab68cd1e9a4c43add01029bc847f5348fd895c09179ee6120ce113642bd.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
